module.exports = __webpack_public_path__ + "img/de.7c02fdf5.png";